import {
    ADD_COPILOT_BOOKMARK,
    ADD_COPILOT_BOOKMARK_FAILURE,
    ADD_COPILOT_BOOKMARK_SUCCESS,
    DELETE_COPILOT_BOOKMARK,
    DELETE_COPILOT_BOOKMARK_FAILURE,
    DELETE_COPILOT_BOOKMARK_SUCCESS,
    ADD_SCREENSHOT,
    ADD_SCREENSHOT_FAILURE,
    ADD_SCREENSHOT_SUCCESS,
    AI_ASSISTED_VALIDATE,
    AI_ASSISTED_VALIDATE_FAILURE,
    AI_ASSISTED_VALIDATE_SUCCESS,
    AI_CODING_COMMENT,
    AI_CODING_COMMENT_FAILURE,
    AI_CODING_COMMENT_SUCCESS,
    AI_SCREENING_COMMENT,
    AI_SCREENING_COMMENT_FAILURE,
    AI_SCREENING_COMMENT_SUCCESS,
    AUTO_APPROVE_FEEDBACK,
    AUTO_APPROVE_FEEDBACK_FAILURE,
    AUTO_APPROVE_FEEDBACK_SUCCESS,
    CANDIDATE_CALL_END,
    CANDIDATE_CALL_END_FAILURE,
    CANDIDATE_CALL_END_SUCCESS,
    CODE_EDITOR_LANGUAGE,
    CODE_EDITOR_LANGUAGE_FAILURE,
    CODE_EDITOR_LANGUAGE_SUCCESS,
    CONTACT_ADMIN,
    CONTACT_ADMIN_FAILURE,
    CONTACT_ADMIN_SUCCESS,
    CREATE_AND_UPDATE_SCREENSHOT,
    CREATE_AND_UPDATE_SCREENSHOT_FAILURE,
    CREATE_AND_UPDATE_SCREENSHOT_SUCCESS,
    CREATE_CODE_SUBMISSION,
    CREATE_CODE_SUBMISSION_FAILURE,
    CREATE_CODE_SUBMISSION_SUCCESS,
    DELETE_RECORDING,
    DELETE_RECORDING_FAILURE,
    DELETE_RECORDING_SUCCESS,
    FACE_EXPRESSION,
    FACE_EXPRESSION_FAILURE,
    FACE_EXPRESSION_SUCCESS,
    FETCH_SCREENSHOT_IMAGE,
    FETCH_SCREENSHOT_IMAGE_FAILURE,
    FETCH_SCREENSHOT_IMAGE_TYPE1_SUCCESS,
    FETCH_SCREENSHOT_IMAGE_TYPE2_SUCCESS,
    FETCH_SCREENSHOT_IMAGE_TYPE3_SUCCESS,
    FETCH_SCREENSHOT_IMAGE_TYPE4_SUCCESS,
    FETCH_SCREENSHOT_IMAGE_TYPE5_SUCCESS,
    FETCH_SCREENSHOT_IMAGEV2,
    FETCH_SCREENSHOT_IMAGEV2_FAILURE,
    FETCH_SCREENSHOT_IMAGEV2_SUCCESS,
    FETCH_SCREENSHOT_IMAGEV3,
    FETCH_SCREENSHOT_IMAGEV3_FAILURE,
    FETCH_SCREENSHOT_IMAGEV3_SUCCESS,
    FETCH_TRANSCRIPT,
    FETCH_TRANSCRIPT_FAILURE,
    FETCH_TRANSCRIPT_SUCCESS,
    FULL_FACE_DETECTION_NEW,
    FULL_FACE_DETECTION_NEW_FAILURE,
    FULL_FACE_DETECTION_NEW_SUCCESS,
    GENERATE_AI_COMMENT,
    GENERATE_AI_COMMENT_FAILURE,
    GENERATE_AI_COMMENT_SUCCESS,
    GENERATE_CANDIDATE_FEEDBACK,
    GENERATE_CANDIDATE_FEEDBACK_FAILURE,
    GENERATE_CANDIDATE_FEEDBACK_SUCCESS,
    GENERATE_RESUME_SUMMARY,
    GENERATE_RESUME_SUMMARY_FAILURE,
    GENERATE_RESUME_SUMMARY_SUCCESS,
    GET_AI_COPILOT_QUESTIONS,
    GET_AI_COPILOT_QUESTIONS_FAILURE,
    GET_AI_COPILOT_QUESTIONS_SUCCESS,
    GET_ALL_SCREENSHOT,
    GET_ALL_SCREENSHOT_FAILURE,
    GET_ALL_SCREENSHOT_SUCCESS,
    GET_CANDIDATE_INTERVIEW_DETAILS,
    GET_CANDIDATE_INTERVIEW_DETAILS_FAILURE,
    GET_CANDIDATE_INTERVIEW_DETAILS_SUCCESS,
    GET_CODE_SUBMISSION,
    GET_CODE_SUBMISSION_FAILURE,
    GET_CODE_SUBMISSION_SUCCESS,
    GET_COPILOT_BOOKMARKS,
    GET_COPILOT_BOOKMARKS_FAILURE,
    GET_COPILOT_BOOKMARKS_SUCCESS,
    GET_CROP_IMAGE,
    GET_CROP_IMAGE_FAILURE,
    GET_CROP_IMAGE_SUCCESS,
    GET_FEEDBACK,
    GET_FEEDBACK_FAILURE,
    GET_FEEDBACK_SUCCESS,
    GET_FINAL_TRANSCRIPT,
    GET_FINAL_TRANSCRIPT_FAILURE,
    GET_FINAL_TRANSCRIPT_SUCCESS,
    GET_INTERVIEW_DETAILS,
    GET_INTERVIEW_DETAILS_FAILURE,
    GET_INTERVIEW_DETAILS_SUCCESS,
    GET_INTERVIEW_TOKEN,
    GET_INTERVIEW_TOKEN_FAILURE,
    GET_INTERVIEW_TOKEN_SUCCESS,
    GET_INTERVIEWER_INTERVIEW_DETAILS,
    GET_INTERVIEWER_INTERVIEW_DETAILS_FAILURE,
    GET_INTERVIEWER_INTERVIEW_DETAILS_SUCCESS,
    GET_RECORDING_LIST,
    GET_RECORDING_LIST_FAILURE,
    GET_RECORDING_LIST_SUCCESS,
    GET_REGENERATED_AI_SUMMARY,
    GET_REGENERATED_AI_SUMMARY_FAILURE,
    GET_REGENERATED_AI_SUMMARY_SUCCESS,
    GET_SCREENSHOT,
    GET_SCREENSHOT_FAILURE,
    GET_SCREENSHOT_SUCCESS,
    GET_SKILLS,
    GET_SKILLS_FAILURE,
    GET_SKILLS_SUCCESS,
    GET_URL_GENERATED_ID,
    GET_URL_GENERATED_ID_FAILURE,
    GET_URL_GENERATED_ID_SUCCESS,
    INTERVIEWER_CALL_END,
    INTERVIEWER_CALL_END_FAILURE,
    INTERVIEWER_CALL_END_SUCCESS,
    LOOKING_FORWARD,
    LOOKING_FORWARD_FAILURE,
    LOOKING_FORWARD_SUCCESS,
    MOVEMENT,
    MOVEMENT_FAILURE,
    MOVEMENT_SUCCESS,
    NOTIFY_INTERVIEWER,
    NOTIFY_INTERVIEWER_FAILURE,
    NOTIFY_INTERVIEWER_SUCCESS,
    PASS_CHECK_MANUALLY,
    PASS_CHECK_MANUALLY_FAILURE,
    PASS_CHECK_MANUALLY_SUCCESS,
    POST_ANALYTICS,
    POST_ANALYTICS_FAILURE,
    POST_ANALYTICS_SUCCESS,
    POST_CAR_FEEDBACK_DETAILS,
    POST_CAR_FEEDBACK_DETAILS_FAILURE,
    POST_CAR_FEEDBACK_DETAILS_SUCCESS,
    POST_CONSENT,
    POST_CONSENT_FAILURE,
    POST_CONSENT_SUCCESS,
    POST_FEEDBACK_DETAILS,
    POST_FEEDBACK_DETAILS_FAILURE,
    POST_FEEDBACK_DETAILS_SUCCESS,
    POST_INTERVIEW_FEEDBACK,
    POST_INTERVIEW_FEEDBACK_FAILURE,
    POST_INTERVIEW_FEEDBACK_SUCCESS,
    POST_NOSHOW_FEEDBACK_DETAILS,
    POST_NOSHOW_FEEDBACK_DETAILS_FAILURE,
    POST_NOSHOW_FEEDBACK_DETAILS_SUCCESS,
    QUESTION_BANK,
    QUESTION_BANK_FAILURE,
    QUESTION_BANK_LIST,
    QUESTION_BANK_LIST_FAILURE,
    QUESTION_BANK_LIST_SUCCESS,
    QUESTION_BANK_SUCCESS,
    REMOVE_SCREENSHOT_IMAGE,
    ROOM_UPDATE,
    ROOM_UPDATE_FAILURE,
    ROOM_UPDATE_SUCCESS,
    SAVE_RESUME_SUMMARY,
    SAVE_RESUME_SUMMARY_FAILURE,
    SAVE_RESUME_SUMMARY_SUCCESS,
    SET_SHOW_FEEDBACK_PORTAL,
    SINGLE_CODE_EDITOR_LANGUAGE,
    SINGLE_CODE_EDITOR_LANGUAGE_FAILURE,
    SINGLE_CODE_EDITOR_LANGUAGE_SUCCESS,
    START_MEETING,
    START_MEETING_FAILURE,
    START_MEETING_SUCCESS,
    SWITCH_TAB,
    SWITCH_TAB_FAILURE,
    SWITCH_TAB_SUCCESS,
    UPDATE_JOIN_NAME,
    UPDATE_JOIN_NAME_FAILURE,
    UPDATE_JOIN_NAME_SUCCESS,
    UPLOAD_AUDIO_AND_ANALYSE,
    UPLOAD_AUDIO_AND_ANALYSE_FAILURE,
    UPLOAD_AUDIO_AND_ANALYSE_SUCCESS,
    UPLOAD_CANDIDATE_VIDEO,
    UPLOAD_CANDIDATE_VIDEO_FAILURE,
    UPLOAD_CANDIDATE_VIDEO_SUCCESS,
    VERIFY_INTERVIEW_KEY,
    VERIFY_INTERVIEW_KEY_FAILURE,
    VERIFY_INTERVIEW_KEY_SUCCESS,
    VIDEO_UPLOAD,
    VIDEO_UPLOAD_FAILURE,
    VIDEO_UPLOAD_SUCCESS,
} from './types';

export const faceExpression = (payload) => ({
    type: FACE_EXPRESSION,
    payload,
});
export const faceExpressionSuccess = (payload) => ({
    type: FACE_EXPRESSION_SUCCESS,
    payload,
});
export const faceExpressionFailure = () => ({
    type: FACE_EXPRESSION_FAILURE,
});

export const uploadCandidateVideo = (payload) => ({
    type: UPLOAD_CANDIDATE_VIDEO,
    payload,
});
export const uploadCandidateVideoSuccess = (payload) => ({
    type: UPLOAD_CANDIDATE_VIDEO_SUCCESS,
    payload,
});
export const uploadCandidateVideoFailure = () => ({
    type: UPLOAD_CANDIDATE_VIDEO_FAILURE,
});

export const aiAssistedValidate = (payload) => ({
    type: AI_ASSISTED_VALIDATE,
    payload,
});
export const aiAssistedValidateSuccess = () => ({
    type: AI_ASSISTED_VALIDATE_SUCCESS,
});
export const aiAssistedValidateFailure = () => ({
    type: AI_ASSISTED_VALIDATE_FAILURE,
});

export const updateJoinName = (payload) => ({
    type: UPDATE_JOIN_NAME,
    payload,
});
export const updateJoinNameSuccess = () => ({
    type: UPDATE_JOIN_NAME_SUCCESS,
});
export const updateJoinNameFailure = () => ({
    type: UPDATE_JOIN_NAME_FAILURE,
});

export const postAnalytics = (payload) => ({
    type: POST_ANALYTICS,
    payload,
});
export const postAnalyticsSuccess = () => ({
    type: POST_ANALYTICS_SUCCESS,
});
export const postAnalyticsFailure = () => ({
    type: POST_ANALYTICS_FAILURE,
});

export const postCarFeedbackDetails = (payload) => ({
    type: POST_CAR_FEEDBACK_DETAILS,
    payload,
});
export const postCarFeedbackDetailsSuccess = () => ({
    type: POST_CAR_FEEDBACK_DETAILS_SUCCESS,
});
export const postCarFeedbackDetailsFailure = () => ({
    type: POST_CAR_FEEDBACK_DETAILS_FAILURE,
});

export const roomUpdate = (payload) => ({
    type: ROOM_UPDATE,
    payload,
});
export const roomUpdateSuccess = () => ({
    type: ROOM_UPDATE_SUCCESS,
});
export const roomUpdateFailure = () => ({
    type: ROOM_UPDATE_FAILURE,
});

export const movementRequest = (payload) => ({
    type: MOVEMENT,
    payload,
});
export const movementSuccess = () => ({
    type: MOVEMENT_SUCCESS,
});
export const movementFailure = () => ({
    type: MOVEMENT_FAILURE,
});

export const switchTab = (payload) => ({
    type: SWITCH_TAB,
    payload,
});
export const switchTabSuccess = () => ({
    type: SWITCH_TAB_SUCCESS,
});
export const switchTabFailure = () => ({
    type: SWITCH_TAB_FAILURE,
});

export const postNoShowFeedbackDetails = (payload) => ({
    type: POST_NOSHOW_FEEDBACK_DETAILS,
    payload,
});
export const postNoShowFeedbackDetailsSuccess = () => ({
    type: POST_NOSHOW_FEEDBACK_DETAILS_SUCCESS,
});
export const postNoShowFeedbackDetailsFailure = () => ({
    type: POST_NOSHOW_FEEDBACK_DETAILS_FAILURE,
});

export const notifyInterviewer = (payload) => ({
    type: NOTIFY_INTERVIEWER,
    payload,
});
export const notifyInterviewerSuccess = () => ({
    type: NOTIFY_INTERVIEWER_SUCCESS,
});
export const notifyInterviewerFailure = () => ({
    type: NOTIFY_INTERVIEWER_FAILURE,
});

export const getCropUrl = (payload) => ({
    type: GET_CROP_IMAGE,
    payload,
});
export const getCropUrlSuccess = (payload) => ({
    type: GET_CROP_IMAGE_SUCCESS,
    payload,
});
export const getCropUrlFailure = () => ({
    type: GET_CROP_IMAGE_FAILURE,
});

export const getAllScreenshots = (payload) => ({
    type: GET_ALL_SCREENSHOT,
    payload,
});
export const getAllScreenshotsSuccess = (payload) => ({
    type: GET_ALL_SCREENSHOT_SUCCESS,
    payload,
});
export const getAllScreenshotsFailure = () => ({
    type: GET_ALL_SCREENSHOT_FAILURE,
});

export const getScreenshots = (payload) => ({
    type: GET_SCREENSHOT,
    payload,
});
export const getScreenshotsSuccess = (payload) => ({
    type: GET_SCREENSHOT_SUCCESS,
    payload,
});
export const getScreenshotsFailure = () => ({
    type: GET_SCREENSHOT_FAILURE,
});

export const createAndUpdateScreenshots = (payload) => ({
    type: CREATE_AND_UPDATE_SCREENSHOT,
    payload,
});
export const createAndUpdateScreenshotsSuccess = (payload) => ({
    type: CREATE_AND_UPDATE_SCREENSHOT_SUCCESS,
    payload,
});
export const createAndUpdateScreenshotsFailure = () => ({
    type: CREATE_AND_UPDATE_SCREENSHOT_FAILURE,
});

export const addScreenshot = (payload) => ({
    type: ADD_SCREENSHOT,
    payload,
});
export const addScreenshotSuccess = (payload) => ({
    type: ADD_SCREENSHOT_SUCCESS,
    payload,
});
export const addScreenshotFailure = () => ({
    type: ADD_SCREENSHOT_FAILURE,
});

export const getRecordings = (payload) => ({
    type: GET_RECORDING_LIST,
    payload,
});
export const getRecordingsSuccess = (payload) => ({
    type: GET_RECORDING_LIST_SUCCESS,
    payload,
});
export const getRecordingsFailure = () => ({
    type: GET_RECORDING_LIST_FAILURE,
});

export const deleteRecording = (payload) => ({
    type: DELETE_RECORDING,
    payload,
});

export const deleteRecordingSuccess = (payload) => ({
    type: DELETE_RECORDING_SUCCESS,
    payload,
});
export const deleteRecordingFailure = () => ({
    type: DELETE_RECORDING_FAILURE,
});

export const candidateCallEnd = (payload) => ({
    type: CANDIDATE_CALL_END,
    payload,
});
export const candidateCallEndSuccess = (payload) => ({
    type: CANDIDATE_CALL_END_SUCCESS,
    payload,
});
export const candidateCallEndFailure = () => ({
    type: CANDIDATE_CALL_END_FAILURE,
});

export const interviewerCallEnd = (payload) => ({
    type: INTERVIEWER_CALL_END,
    payload,
});
export const interviewerCallEndSuccess = (payload) => ({
    type: INTERVIEWER_CALL_END_SUCCESS,
    payload,
});
export const interviewerCallEndFailure = () => ({
    type: INTERVIEWER_CALL_END_FAILURE,
});

export const getSkills = () => ({
    type: GET_SKILLS,
});
export const getSkillsSuccess = (payload) => ({
    type: GET_SKILLS_SUCCESS,
    payload,
});
export const getSkillsFailure = () => ({
    type: GET_SKILLS_FAILURE,
});

export const getFeedback = (payload) => ({
    type: GET_FEEDBACK,
    payload,
});
export const getFeedbackSuccess = (payload) => ({
    type: GET_FEEDBACK_SUCCESS,
    payload,
});
export const getFeedbackFailure = () => ({
    type: GET_FEEDBACK_FAILURE,
});

export const verifyInterviewKey = (payload) => ({
    type: VERIFY_INTERVIEW_KEY,
    payload,
});
export const verifyInterviewKeySuccess = (payload) => ({
    type: VERIFY_INTERVIEW_KEY_SUCCESS,
    payload,
});
export const verifyInterviewKeyFailure = () => ({
    type: VERIFY_INTERVIEW_KEY_FAILURE,
});

export const removeScreenShotImage = () => ({
    type: REMOVE_SCREENSHOT_IMAGE,
});
export const fetchScreenShotImage = (payload) => ({
    type: FETCH_SCREENSHOT_IMAGE,
    payload,
});
export const fetchScreenShotImageType1Success = (payload) => ({
    type: FETCH_SCREENSHOT_IMAGE_TYPE1_SUCCESS,
    payload,
});
export const fetchScreenShotImageType2Success = (payload) => ({
    type: FETCH_SCREENSHOT_IMAGE_TYPE2_SUCCESS,
    payload,
});
export const fetchScreenShotImageType3Success = (payload) => ({
    type: FETCH_SCREENSHOT_IMAGE_TYPE3_SUCCESS,
    payload,
});
export const fetchScreenShotImageType4Success = (payload) => ({
    type: FETCH_SCREENSHOT_IMAGE_TYPE4_SUCCESS,
    payload,
});
export const fetchScreenShotImageType5Success = (payload) => ({
    type: FETCH_SCREENSHOT_IMAGE_TYPE5_SUCCESS,
    payload,
});
export const fetchScreenShotImageFailure = () => ({
    type: FETCH_SCREENSHOT_IMAGE_FAILURE,
});

export const fetchScreenShotImagev2 = (payload) => ({
    type: FETCH_SCREENSHOT_IMAGEV2,
    payload,
});
export const fetchScreenShotImagev2Success = (payload) => ({
    type: FETCH_SCREENSHOT_IMAGEV2_SUCCESS,
    payload,
});
export const fetchScreenShotImagev2Failure = () => ({
    type: FETCH_SCREENSHOT_IMAGEV2_FAILURE,
});

export const fetchScreenShotImagev3 = (payload) => ({
    type: FETCH_SCREENSHOT_IMAGEV3,
    payload,
});
export const fetchScreenShotImagev3Success = (payload) => ({
    type: FETCH_SCREENSHOT_IMAGEV3_SUCCESS,
    payload,
});
export const fetchScreenShotImagev3Failure = () => ({
    type: FETCH_SCREENSHOT_IMAGEV3_FAILURE,
});

export const getQuestionBank = (payload) => ({
    type: QUESTION_BANK,
    payload,
});
export const getQuestionBankSuccess = (payload) => ({
    type: QUESTION_BANK_SUCCESS,
    payload,
});
export const getQuestionBankFailure = () => ({
    type: QUESTION_BANK_FAILURE,
});

export const getQuestionBankLanguageList = () => ({
    type: QUESTION_BANK_LIST,
});
export const getQuestionBankListSuccess = (payload) => ({
    type: QUESTION_BANK_LIST_SUCCESS,
    payload,
});
export const getQuestionBankListFailure = () => ({
    type: QUESTION_BANK_LIST_FAILURE,
});

export const getInterviewDetails = (payload) => ({
    type: GET_INTERVIEW_DETAILS,
    payload,
});
export const getInterviewDetailsSuccess = (payload) => ({
    type: GET_INTERVIEW_DETAILS_SUCCESS,
    payload,
});
export const getInterviewDetailsFailure = () => ({
    type: GET_INTERVIEW_DETAILS_FAILURE,
});

export const getCandidateInterviewDetails = () => ({
    type: GET_CANDIDATE_INTERVIEW_DETAILS,
});
export const getCandidateInterviewDetailsSuccess = (payload) => ({
    type: GET_CANDIDATE_INTERVIEW_DETAILS_SUCCESS,
    payload,
});
export const getCandidateInterviewDetailsFailure = () => ({
    type: GET_CANDIDATE_INTERVIEW_DETAILS_FAILURE,
});

export const getInterviewerInterviewDetails = (payload) => ({
    type: GET_INTERVIEWER_INTERVIEW_DETAILS,
    payload,
});
export const getInterviewerInterviewDetailsSuccess = (payload) => ({
    type: GET_INTERVIEWER_INTERVIEW_DETAILS_SUCCESS,
    payload,
});
export const getInterviewerInterviewDetailsFailure = () => ({
    type: GET_INTERVIEWER_INTERVIEW_DETAILS_FAILURE,
});

export const getInterviewToken = (payload) => ({
    type: GET_INTERVIEW_TOKEN,
    payload,
});
export const getInterviewTokenSuccess = (payload) => ({
    type: GET_INTERVIEW_TOKEN_SUCCESS,
    payload,
});
export const getInterviewTokenFailure = () => ({
    type: GET_INTERVIEW_TOKEN_FAILURE,
});

export const postFeedbackDetails = (payload) => ({
    type: POST_FEEDBACK_DETAILS,
    payload,
});
export const postFeedbackDetailsSuccess = () => ({
    type: POST_FEEDBACK_DETAILS_SUCCESS,
});
export const postFeedbackDetailsFailure = () => ({
    type: POST_FEEDBACK_DETAILS_FAILURE,
});

export const postInterviewFeedback = (payload) => ({
    type: POST_INTERVIEW_FEEDBACK,
    payload,
});
export const postInterviewFeedbackSuccess = () => ({
    type: POST_INTERVIEW_FEEDBACK_SUCCESS,
});
export const postInterviewFeedbackFailure = () => ({
    type: POST_INTERVIEW_FEEDBACK_FAILURE,
});

export const contactAdmin = (payload) => ({
    type: CONTACT_ADMIN,
    payload,
});
export const contactAdminSuccess = () => ({
    type: CONTACT_ADMIN_SUCCESS,
});
export const contactAdminFailure = () => ({
    type: CONTACT_ADMIN_FAILURE,
});

export const getCodeEditorLanguages = () => ({
    type: CODE_EDITOR_LANGUAGE,
});
export const getCodeEditorLanguagesSuccess = (payload) => ({
    type: CODE_EDITOR_LANGUAGE_SUCCESS,
    payload,
});
export const getCodeEditorLanguagesFailure = () => ({
    type: CODE_EDITOR_LANGUAGE_FAILURE,
});

export const getSingleCodeEditorLanguages = (payload) => ({
    type: SINGLE_CODE_EDITOR_LANGUAGE,
    payload,
});
export const getSingleCodeEditorLanguagesSuccess = (payload) => ({
    type: SINGLE_CODE_EDITOR_LANGUAGE_SUCCESS,
    payload,
});
export const getSingleCodeEditorLanguagesFailure = () => ({
    type: SINGLE_CODE_EDITOR_LANGUAGE_FAILURE,
});

export const getCodeSubmission = (payload) => ({
    type: GET_CODE_SUBMISSION,
    payload,
});
export const getCodeSubmissionSuccess = (payload) => ({
    type: GET_CODE_SUBMISSION_SUCCESS,
    payload,
});
export const getCodeSubmissionFailure = () => ({
    type: GET_CODE_SUBMISSION_FAILURE,
});

export const createCodeSubmission = (payload) => ({
    type: CREATE_CODE_SUBMISSION,
    payload,
});
export const createCodeSubmissionSuccess = (payload) => ({
    type: CREATE_CODE_SUBMISSION_SUCCESS,
    payload,
});
export const createCodeSubmissionFailure = () => ({
    type: CREATE_CODE_SUBMISSION_FAILURE,
});

export const setShowFeedbackPortal = (payload) => ({
    type: SET_SHOW_FEEDBACK_PORTAL,
    payload,
});

// zoom sdk
export const startMeeting = (payload) => ({
    type: START_MEETING,
    payload,
});

export const startMeetingSuccess = (payload) => ({
    type: START_MEETING_SUCCESS,
    payload,
});

export const startMeetingFailure = () => ({
    type: START_MEETING_FAILURE,
});

// url generated id
export const getUrlGeneratedId = (payload) => ({
    type: GET_URL_GENERATED_ID,
    payload,
});

export const getUrlGeneratedIdSuccess = (payload) => ({
    type: GET_URL_GENERATED_ID_SUCCESS,
    payload,
});

export const getUrlGeneratedIdFailure = () => ({
    type: GET_URL_GENERATED_ID_FAILURE,
});
// Regenerate AI summary
export const getRegeneratedAiSummary = (payload) => ({
    type: GET_REGENERATED_AI_SUMMARY,
    payload,
});

export const getRegeneratedAiSummarySuccess = (payload) => ({
    type: GET_REGENERATED_AI_SUMMARY_SUCCESS,
    payload,
});

export const getRegeneratedAiSummaryFailure = () => ({
    type: GET_REGENERATED_AI_SUMMARY_FAILURE,
});
export const fetchTranscript = (payload) => ({
    type: FETCH_TRANSCRIPT,
    payload,
});
export const fetchTranscriptSuccess = () => ({
    type: FETCH_TRANSCRIPT_SUCCESS,
});
export const fetchTranscriptFailure = () => ({
    type: FETCH_TRANSCRIPT_FAILURE,
});
export const getFinalTranscript = (payload) => ({
    type: GET_FINAL_TRANSCRIPT,
    payload,
});
export const getFinalTranscriptSuccess = (payload) => ({
    type: GET_FINAL_TRANSCRIPT_SUCCESS,
    payload,
});
export const getFinalTranscriptFailure = () => ({
    type: GET_FINAL_TRANSCRIPT_FAILURE,
});
// Video Upload
export const videoUpload = (payload) => ({
    type: VIDEO_UPLOAD,
    payload,
});
export const videoUploadSuccess = () => ({
    type: VIDEO_UPLOAD_SUCCESS,
});
export const videoUploadFailure = () => ({
    type: VIDEO_UPLOAD_FAILURE,
});

export const postConsent = (payload) => ({
    type: POST_CONSENT,
    payload,
});
export const postConsentSuccess = (payload) => ({
    type: POST_CONSENT_SUCCESS,
    payload,
});
export const postConsentFailure = () => ({
    type: POST_CONSENT_FAILURE,
});
export const lookingForward = (payload) => ({
    type: LOOKING_FORWARD,
    payload,
});
export const lookingForwardSuccess = () => ({
    type: LOOKING_FORWARD_SUCCESS,
});
export const lookingForwardFailure = () => ({
    type: LOOKING_FORWARD_FAILURE,
});
export const generateAIComment = (payload) => ({
    type: GENERATE_AI_COMMENT,
    payload,
});
export const generateAICommentSuccess = () => ({
    type: GENERATE_AI_COMMENT_SUCCESS,
});
export const generateAICommentFailure = () => ({
    type: GENERATE_AI_COMMENT_FAILURE,
});

export const uploadAudioAndAnalyse = (payload) => ({
    type: UPLOAD_AUDIO_AND_ANALYSE,
    payload,
});
export const uploadAudioAndAnalyseSuccess = (payload) => ({
    type: UPLOAD_AUDIO_AND_ANALYSE_SUCCESS,
    payload,
});
export const uploadAudioAndAnalyseFailure = () => ({
    type: UPLOAD_AUDIO_AND_ANALYSE_FAILURE,
});

export const fullFaceDetectionNew = (payload) => ({
    type: FULL_FACE_DETECTION_NEW,
    payload,
});
export const fullFaceDetectionNewSuccess = (payload) => ({
    type: FULL_FACE_DETECTION_NEW_SUCCESS,
    payload,
});
export const fullFaceDetectionNewFailure = (payload) => ({
    type: FULL_FACE_DETECTION_NEW_FAILURE,
    payload,
});

export const aiCodingComment = (payload) => ({
    type: AI_CODING_COMMENT,
    payload,
});
export const aiCodingCommentSuccess = (payload) => ({
    type: AI_CODING_COMMENT_SUCCESS,
    payload,
});
export const aiCodingCommentFailure = () => ({
    type: AI_CODING_COMMENT_FAILURE,
});

export const aiScreeningComment = (payload) => ({
    type: AI_SCREENING_COMMENT,
    payload,
});
export const aiScreeningCommentSuccess = (payload) => ({
    type: AI_SCREENING_COMMENT_SUCCESS,
    payload,
});
export const aiScreeningCommentFailure = () => ({
    type: AI_SCREENING_COMMENT_FAILURE,
});

export const generateCandidateFeedback = (payload) => ({
    type: GENERATE_CANDIDATE_FEEDBACK,
    payload,
});
export const generateCandidateFeedbackSuccess = (payload) => ({
    type: GENERATE_CANDIDATE_FEEDBACK_SUCCESS,
    payload,
});
export const generateCandidateFeedbackFailure = () => ({
    type: GENERATE_CANDIDATE_FEEDBACK_FAILURE,
});

export const passCheckManually = (payload) => ({
    type: PASS_CHECK_MANUALLY,
    payload,
});
export const passCheckManuallySuccess = (payload) => ({
    type: PASS_CHECK_MANUALLY_SUCCESS,
    payload,
});
export const passCheckManuallyFailure = () => ({
    type: PASS_CHECK_MANUALLY_FAILURE,
});

export const autoApproveFeedback = (payload) => ({
    type: AUTO_APPROVE_FEEDBACK,
    payload,
});
export const autoApproveFeedbackSuccess = (payload) => ({
    type: AUTO_APPROVE_FEEDBACK_SUCCESS,
    payload,
});
export const autoApproveFeedbackFailure = () => ({
    type: AUTO_APPROVE_FEEDBACK_FAILURE,
});

export const generateResumeSummary = (payload) => ({
    type: GENERATE_RESUME_SUMMARY,
    payload,
});
export const generateResumeSummarySuccess = (payload) => ({
    type: GENERATE_RESUME_SUMMARY_SUCCESS,
    payload,
});
export const generateResumeSummaryFailure = () => ({
    type: GENERATE_RESUME_SUMMARY_FAILURE,
});

export const saveResumeSummary = (payload) => ({
    type: SAVE_RESUME_SUMMARY,
    payload,
});
export const saveResumeSummarySuccess = () => ({
    type: SAVE_RESUME_SUMMARY_SUCCESS,
});
export const saveResumeSummaryFailure = () => ({
    type: SAVE_RESUME_SUMMARY_FAILURE,
});
// AI Copilot
export const getAiCopilotQuestions = (payload) => ({ type: GET_AI_COPILOT_QUESTIONS, payload });
export const getAiCopilotQuestionsSuccess = (payload) => ({ type: GET_AI_COPILOT_QUESTIONS_SUCCESS, payload });
export const getAiCopilotQuestionsFailure = () => ({ type: GET_AI_COPILOT_QUESTIONS_FAILURE });

export const getCopilotBookmarks = (payload) => ({ type: GET_COPILOT_BOOKMARKS, payload });
export const getCopilotBookmarksSuccess = (payload) => ({ type: GET_COPILOT_BOOKMARKS_SUCCESS, payload });
export const getCopilotBookmarksFailure = () => ({ type: GET_COPILOT_BOOKMARKS_FAILURE });

export const addCopilotBookmark = (payload) => ({ type: ADD_COPILOT_BOOKMARK, payload });
export const addCopilotBookmarkSuccess = (payload) => ({ type: ADD_COPILOT_BOOKMARK_SUCCESS, payload });
export const addCopilotBookmarkFailure = () => ({ type: ADD_COPILOT_BOOKMARK_FAILURE });

export const deleteCopilotBookmark = (payload) => ({ type: DELETE_COPILOT_BOOKMARK, payload });
export const deleteCopilotBookmarkSuccess = (payload) => ({ type: DELETE_COPILOT_BOOKMARK_SUCCESS, payload });
export const deleteCopilotBookmarkFailure = () => ({ type: DELETE_COPILOT_BOOKMARK_FAILURE });
